var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{attrs:{"to":"../catalogo/carrello"}},[_c('feather-icon',{attrs:{"size":"21","icon":"ShoppingCartIcon","badge":_vm.$store.state['app-ecommerce'].cartItemsCount}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }